import { forwardRef, Ref } from 'react';
import * as Accordion from '@radix-ui/react-accordion';
import { StyledAccordionContent } from './Accordion.styled';

export const AccordionContent = forwardRef(
  ({ children, ...props }: Accordion.AccordionContentProps, forwardedRef?: Ref<HTMLDivElement>) => (
    <StyledAccordionContent forceMount {...props} ref={forwardedRef}>
      {children}
    </StyledAccordionContent>
  ),
);
